import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {IElGordosRevengeGameData} from "./server/data/IElGordosRevengeData";
import {ElGordosRevengeSound} from "./sound/ElGordosRevengeSound";
import {ElGordosRevenge} from "./ElGordosRevenge";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class ElGordosRevengePromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {}

    public getActionSpinOptions():ActionSpinOptions {
        return {
            gameName : "ElGordos Revenge",
            hasActionSpin : true,
            mainGame : {
                header : () => "xBET",
                options : [
                    {name : "NORMAL", id : 0, image : "NORMAL.png"},
                    {name : "BOOSTED_BET_1", id : 1, image : "BOOSTED_BET_1.png"},
                    {name : "BOOSTED_BET_2", id : 1, image : "BOOSTED_BET_2.png"},
                    {name : "BOOSTED_BET_3", id : 1, image : "BOOSTED_BET_3.png"},
                    {name : "BOOSTED_BET_4", id : 1, image : "BOOSTED_BET_4.png"}
                ],
                type : ASMainGamePickOptions.BOOSTED_BET
            },
            graphics : {backgroundTextureName : "introBg"},
            getParsedData : (response:IElGordosRevengeGameData, bet:number, prevResponse:IElGordosRevengeGameData):ASWinData => {
                const parsedData:ASWinData = {
                    totalWin : response.accumulatedRoundWin,
                    wasFeatureBuy : response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin : this.isFreeSpinTriggered(response),
                    totalSpinWinnings : +response.totalSpinWinnings,
                    isBigWin : this.isBigWin(response),
                    winType : WINTYPE.NORMAL,
                    featureName : this.getFeatureName(response),
                    isRoundComplete : this.isRoundComplete(response),
                    isBonusEnd : this.isBonusEnd(response),
                    isWinCapHit : response.brokeTheBank,
                }
                return parsedData;
            }
        };
    }

    private isFreeSpinTriggered(response:IElGordosRevengeGameData):boolean {
        return response.freespinTriggeredThisSpin === true; //(response.mode === TombstoneRipGameMode.NORMAL) && response.nextMode === TombstoneRipGameMode.FREESPIN;
    }

    private isBigWin(response:IElGordosRevengeGameData):boolean {
        let win = response.totalSpinWinnings;

        if(response.wasFeatureBuy || ElGordosRevenge.model.buyFeatureName === "BOOSTED_BET_3" || ElGordosRevenge.model.buyFeatureName === "BOOSTED_BET_4") {
            const betPrice = BelowStakeWinRestriction.getBuyFeaturePrice();
            let winRatio:number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio:number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        if(response.mode.includes("SUPER")) {
            return winRatio >= 50;
        }
        return winRatio >= 25;
    }

    private getFeatureName(response:IElGordosRevengeGameData):string {
        if((response.mode == GameMode.FREESPIN) || response.nextMode == GameMode.FREESPIN) {
            return "SLAUGHTER SPINS";
        }

        if((response.mode == GameMode.FREESPIN_SUPER) || response.nextMode == GameMode.FREESPIN_SUPER) {
            return "MASSACRE SPINS";
        }

        return response.mode;
    }

    private isRoundComplete(response:IElGordosRevengeGameData):boolean {
        return ([GameMode.FREESPIN, GameMode.FREESPIN_SUPER, GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response:IElGordosRevengeGameData):boolean {
        return (response.nextMode === GameMode.NORMAL) && (response.mode === GameMode.FREESPIN || response.mode === GameMode.FREESPIN_SUPER);
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if(trigger == ActionSpinSound.WIN) {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.AS_WIN});
        } else if(trigger == ActionSpinSound.BIG_WIN) {
            ElGordosRevengeSound.soundPlayer.playTrack({name : ElGordosRevengeSound.AS_WIN_BIG});
        }
    }
}